// extracted by mini-css-extract-plugin
export default {"mCard":"iD-z","image":"jD-z","imageNoBackground":"kD-z","imageHasCategory":"lD-z","fullWidth":"mD-z"};